import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname ?? '/';

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-silver-50">
      <div className="w-full max-w-sm">
        {/* Brand */}
        <div className="mb-8 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-ds-008 bg-purple-500">
            <span className="text-xl font-bold text-white">S</span>
          </div>
          <h1 className="mt-4 text-2xl font-bold text-carbon-900">Survey CMS</h1>
          <p className="mt-1 text-sm text-carbon-500">CareMonitor Admin Portal</p>
        </div>

        {/* Login form */}
        <form
          onSubmit={handleSubmit}
          className="rounded-ds-008 border border-silver-200 bg-white p-6 shadow-sm"
        >
          <div className="space-y-4">
            <div>
              <label htmlFor="identifier" className="block text-sm font-medium text-carbon-700 mb-1">
                Username or email
              </label>
              <Input
                id="identifier"
                type="text"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="username or you@example.com"
                required
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-carbon-700 mb-1">
                Password
              </label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
              />
            </div>

            {error && (
              <p className="text-sm text-red-600">{error}</p>
            )}

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </div>

          <p className="mt-4 text-xs text-center text-carbon-400">
            Sign in with your AMC Health credentials
          </p>
        </form>
      </div>
    </div>
  );
}
